<template>
    <el-pagination
        class="paging"
        layout="sizes, prev, pager, next, jumper"
        v-bind="$attrs"
        v-on="$listeners"
        :pageSize="pageSize"
        :current-page.sync="current"
        @current-change="pageChange"
        @size-change="sizeChange"
    ></el-pagination>
</template>

<script>
export default {
    name: 'XxPagination',
    props: {
        pageSize: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            current: 1,
            size: this.pageSize || 10
        };
    },
    methods: {
        sizeChange(size) {
            this.current = 1;
            this.size = +size;
            this.pageChange();
        },
        pageChange() {
            const { size } = this;
            this.$emit('change', { offset: (this.current - 1) * size, limit: size });
        }
    }
};
</script>

<style lang="scss" scoped>
// #00ceb0
.paging {
    text-align: right;
    padding: 0;
    /deep/ {
        * {
            border-radius: 2px;
        }

        .el-pagination__sizes {
            float: left;
            .el-select .el-input.is-focus .el-input__inner {
                border-color: #00ceb0;
            }
        }
        .el-input {
            margin: 0;
            .el-input__inner {
                height: 32px;
                line-height: 32px;
                &:hover,
                &:focus {
                    border-color: #00ceb0;
                }
            }
            &.is-focus {
                .el-input__inner {
                    border-color: #00ceb0;
                }
            }
        }

        .btn-next,
        .btn-prev,
        .el-pager li {
            height: 32px;
            line-height: 32px;
            color: #636478;
            &:hover {
                color: #a3b9b6;
            }

            &.active {
                background: #00ceb0;
                border-color: #00ceb0;
                color: #fff;
            }
        }
    }
}
</style>
<style>
.el-select-dropdown__item.selected {
    color: #606266;
}
</style>
